module.exports = __webpack_public_path__ + "img/emoji_66.9ae67f89.png";